const A2 = "https://customer-assets-39nsmqrw.emergentagent.net/job_mon-site-web-116--9wlowa4k/artifacts";

export const FRANCE_AVENIR_IMG = `${A2}/f6754ffd489e694e_5%20France%20Avenir%20_%20Agir%20ensemble.png`;

export const DOCS = [
  { id: "intro", title: "MM4S — Introduction · France Avenir", pages: "9 pages", url: `${A2}/44c9e771fce4f15d_7%20%20MM4S_Introduction_FINAL_9_pages_CORRIGEE.pdf` },
  { id: "dette", title: "50 ans de dette — la facture par habitant", pages: "10 pages", url: `${A2}/130495f8249e7cdc_4%20Dette_par_habitant_50_ans_BP_France_avec_aparte_euro.pdf` },
  { id: "bp", title: "Business Plan Entreprise France — plan à 10 ans", pages: "17 pages", url: `${A2}/0e883acddf566d40_8%20%20Business_Plan_Entreprise_France_10_ans_V7_FINAL.pdf` },
];

export const CONSTAT = [
  { label: "Dette publique", big: "3 595,5 Md€", sub: "soit environ 52 050 € par habitant" },
  { label: "Déficit annuel", big: "152,5 Md€", sub: "soit environ 2 215 € par habitant et par an" },
  { label: "Simulation", big: "150 Md€ / an", sub: "30 millions de personnes × 5 000 € par personne et par an" },
  { label: "Besoin total simulé", big: "302,5 Md€ / an", sub: "La règle de trois, c'est déjà un début de réponse.", accent: true },
];

export const FONDS = [
  { amount: "0 €", text: "si l'on doit être protégé (jeunes, personnes en difficulté…)" },
  { amount: "100 € / an", text: "Un geste déjà utile." },
  { amount: "500 € / an", text: "Une contribution concrète." },
  { amount: "2 000 € / an", text: "Pour aller plus loin." },
  { amount: "10 000 € / an ou plus", text: "Pour ceux qui le peuvent." },
];

export const BILAN_JEUNES = [
  ["Recettes fiscales et sociales", "1 200", "—", "—", "—"],
  ["Dépenses publiques", "—", "1 350", "—", "—"],
  ["Déficit annuel", "—", "152,5", "—", "—"],
  ["Dette publique", "—", "—", "3 595,5", "—"],
  ["Actifs (patrimoine public, entreprises…)", "—", "—", "—", "1 800 (estimation)"],
];

export const REGLES = [
  { t: "Règles individuelles", d: "Chacun garde ses choix, ses convictions, sa manière de vivre et ses propres règles. Chacun chez soi. Chacun son indépendance. Tant que la règle collective est respectée." },
  { t: "Règle collective", d: "Vivre ensemble exige une règle commune. Elle doit être simple, connue, compréhensible, applicable et la même pour tous." },
  { t: "Application", d: "Une règle écrite mais non appliquée n'est bientôt plus une règle. Celui qui la fixe doit aussi répondre de son application." },
  { t: "Respect et sanction", d: "Le respect de la règle collective n'est pas facultatif. La sanction n'est pas une vengeance : elle est la conséquence prévue pour celui qui ne respecte pas la règle commune. Même règle, même contrôle, même conséquence." },
];

export const QUI_REGLE = [
  { t: "La machine ?", d: "Elle peut compter, comparer, détecter les incohérences, simuler et recommencer sans fatigue. Elle peut montrer les conséquences des choix." },
  { t: "À votre place ?", d: "Elle peut éclairer. Mais qui lui donne la règle, l'objectif et la limite ? Qui assume la décision ?" },
  { t: "Avec la machine ?", d: "L'homme peut fixer le but ; la machine peut mesurer, contrôler et recalculer lorsque les données changent." },
  { t: "Tous ensemble ?", d: "Enfants, parents, grands-parents, citoyens et institutions : chacun indépendant, tous soumis à la même règle collective." },
];

export const SCENARIO = ["L'homme pose la question.", "La machine aide à l'examiner.", "L'homme choisit.", "La machine recalcule.", "L'homme corrige."];

export const BP_PHOTO = [
  { label: "Entrées", big: "1 561,6 Md€", sub: "Recettes publiques 2025" },
  { label: "Sorties", big: "1 714,1 Md€", sub: "Dépenses publiques 2025" },
  { label: "Différence", big: "−152,5 Md€", sub: "Déficit public 2025", accent: true },
  { label: "Dette", big: "3 595,5 Md€", sub: "Dette publique au T2 2026" },
];

export const BP_SORTIES = [
  ["Prestations sociales", "771 Md€"], ["Rémunérations publiques", "370 Md€"], ["Achats / fonctionnement", "163,5 Md€"],
  ["Intérêts de la dette", "64,7 Md€"], ["Investissements publics", "132,2 Md€"], ["Autres transferts / subventions", "≈192 Md€"],
];

export const BP_FAMILLE = [
  ["≈ 52 050 €", "Dette par habitant"], ["≈ 208 000 €", "Dette pour 4 personnes"], ["≈ 2 215 €", "Déficit annuel par habitant"],
  ["≈ 3 675 €", "Déficit par foyer fiscal"], ["≈ 7 780 €", "Déficit par foyer imposé IR"],
];

export const BP_HOMMES = [
  ["Jeunesse en formation", "≈ 15,5 M", "Écoliers + collégiens + lycéens + étudiants + apprentis"],
  ["Fonction publique", "≈ 5,88 M", "État + territoriale + hospitalière"],
  ["Sous le seuil de pauvreté", "≈ 9,82 M", "Population transversale — ne pas additionner mécaniquement"],
  ["Hôpitaux / cliniques", "≈ 1,41 M", "Public + privé"],
  ["Militaires d'active", "≈ 0,31 M", "Armées + gendarmerie et autres statuts militaires"],
  ["Sapeurs-pompiers", "≈ 0,256 M", "Professionnels + volontaires + militaires"],
];

export const BP_MURS = [
  ["Patrimoine scolaire", "≈ 157 M m²", "200 €/m²/an", "≈ 31,4 Md€/an"],
  ["Collectivités territoriales", "≈ 280 M m²", "200 €/m²/an", "≈ 56,0 Md€/an"],
  ["État + opérateurs", "≈ 96,8 M m²", "200 €/m²/an", "≈ 19,4 Md€/an"],
  ["Hôpitaux publics", "≈ 60 M m²", "300 €/m²/an", "≈ 18,0 Md€/an"],
];

export const BP_DEFENSE = [
  ["≈ 61,8 Md€", "Effort national de défense 2025"], ["≈ 413 Md€", "LPM 2024-2030 · trajectoire programmée"], ["≈ 800 Md€", "Scénario central · hypothèse 10 ans"],
];

export const BP_TRAJECTOIRE = [
  ["1", "−302,5", "+50", "−252,5", "Amorcer"], ["3", "−302,5", "+150", "−152,5", "Moitié du chemin"],
  ["5", "−302,5", "+220", "−82,5", "Accélérer"], ["8", "−302,5", "+280", "−22,5", "Approcher zéro"],
  ["10", "−302,5", "+302,5", "0", "Équilibre"],
];

export const BP_CAPACITE = [
  { t: "Financement identifié", d: "Pas de charge nouvelle permanente sans recette, économie, réallocation ou gain durable clairement identifié." },
  { t: "Séparer les natures", d: "Distinguer fonctionnement courant, investissement, dette, intérêts et dépenses exceptionnelles." },
  { t: "Trajectoire annuelle", d: "Fixer un objectif annuel mesurable : écart à combler, économie réalisée, recette obtenue, dette stabilisée." },
  { t: "Data et contrôle", d: "Publier les données, comparer réel / budget / plan, contrôler de façon indépendante et corriger rapidement." },
  { t: "Clause de correction", d: "Si les recettes ou économies ne sont pas au rendez-vous, la dépense doit être reportée, réduite ou financée autrement." },
  { t: "Priorités", d: "Protéger les 4S — Scolarité, Santé, Sécurité, Solidarité — et arbitrer le reste selon les moyens réels." },
];

export const BP_DIX_ANS = [
  { t: "Année 1", d: "Constater — dire la vérité des chiffres — fixer les règles — protéger les 4S — commencer les investissements." },
  { t: "Années 2 à 5", d: "Réorganiser — automatiser — éliminer les doublons — mesurer les premiers résultats — réinvestir ce qui est économisé ou produit." },
  { t: "Années 6 à 9", d: "Réduire progressivement le déficit — stabiliser la dette — faire apparaître les effets des investissements — restaurer des marges de manœuvre." },
  { t: "Année 10", d: "Faire les comptes : entrées, sorties, dette, actifs, résultat. Et répondre enfin : avons-nous tenu le plan ?" },
];

export const BP_CONTROLES = [
  ["Contrôle politique", "Élections ; contrôle parlementaire ; responsabilité du Gouvernement devant l'Assemblée nationale, jusqu'à la motion de censure."],
  ["Contrôle de constitutionnalité", "Le Conseil constitutionnel contrôle la conformité des lois et intervient aussi dans le contentieux électoral."],
  ["Contrôle de l'argent public", "Cour des comptes et chambres régionales : contrôle, certification, jugement et évaluation du bon emploi de l'argent public."],
  ["Probité et conflits d'intérêts", "HATVP : déclarations de patrimoine et d'intérêts, prévention des conflits d'intérêts, contrôles."],
  ["Sanction", "Sanction politique (élection, censure, démission) et, lorsqu'une infraction est caractérisée, sanctions administratives, financières, civiles ou pénales."],
];

export const BP_CONCLUSION = [
  "Que voulons-nous maintenir ?", "Que voulons-nous améliorer ?", "Que voulons-nous ajouter ?",
  "Combien cela coûte-t-il chaque année ?", "Quelle recette finance quelle dépense ?",
  "Et si les entrées restent inférieures aux sorties… combien de temps ?",
];
